<template>
  <div>
    <el-container>
      <el-container>
        <el-aside width="110px">
          <el-menu
            :default-active="this.$router.path"
            router
            mode="horizontal"
          >
            <el-menu-item
              v-for="(item,i) in navList"
              :key="i"
              :index="item.name"
            >
              {{ item.navItem }}
            </el-menu-item>
          </el-menu>
        </el-aside>

        <el-container>
          <el-main>
            <div style="height:1020px" overflow: auto>
            <router-view />
            </div>
          </el-main>
        </el-container>


      </el-container>
    </el-container>
  </div>
</template>

<script>

/* import listtable from "@/components/listtable.vue";  */

export default {
  components: {
//    listtable
  },
  data() {
    return {
      navList: [
        { name: "/htindex/yygl", navItem: "运营管理" },
        { name: "/htindex/khgl", navItem: "客户管理" },
        { name: "/qtindex/qthomepage", navItem: "前台首页" },
      ]
    };
  }
};
</script>

<style scoped>
.el-header,
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #d3dce6;
  color: #333;
  text-align: left;
  line-height: 200px;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  line-height: 30px;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.el-submenu__title:hover {
  background-color: rgba(14, 221, 240, 0.32) !important;
  width: 100%;
}
.el-menu-item:hover {
  background-color: rgba(14, 221, 240, 0.32) !important;
  width: 100%;
}

</style>